import { Divider, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSetState } from "react-use";
import * as Yup from "yup";

import FormItems, { FormItemLabel, scrollToField } from "../../partials/FormItems/FormItems";
import WidgetImage from "../../partials/Image";
import { useQueryAddresses } from "../../services/AddressService";
import { createRentProduct, RentProduct } from "../../services/commands/product";
import { useQueryImages } from "../../services/ImageService";
import { sendCommandAndAffect } from "../../utils/command";
import Common from "../../utils/Common";
import { asyncToast } from "../../utils/toast";
import {
  formatDateTime,
  getCommonValues,
  stringBooleanToRealBoolean,
} from "../../utils/typeUltils";
import { dataURLtoFile, handleUploadAvatar } from "../deposit/Functions";
import VoucherList, { MessagePromotionResponse } from "./VoucherList";
import { useSelector } from "react-redux";

type Props = {};

const schema = Yup.object().shape({
  addressName: Yup.mixed().required("is a required property"),
  adult: Yup.number()
    .required("is a required property")
    .min(1, "Số người lớn phải lớn hơn 0")
    .max(10, "Số người lớn phải nhỏ hơn 10"),
  children: Yup.number()
    .required("is a required property")
    .min(1, "Số trẻ em phải lớn hơn 0 ")
    .max(10, "Số trẻ em phải nhỏ hơn 10"),
  bedRoom: Yup.mixed().required("is a required property"),

  price: Yup.number()
    .required("is a required property")
    .min(1000000, "Số tiền cho thuê không được dưới 1.000.000"),
});
interface ICalculatePromotion {
  PromotionItems: { PromotionId: string; ApplyBeforeCheckIn }[];
  FromDate: Date;
  Amount: number;
  ModifiedDate: Date;
  ModifiedBy: string;
}
export const calCulatePromotion = (values: ICalculatePromotion) => {
  return sendCommandAndAffect({
    domain: "Promotion",
    name: "CalculateDiscountProductVacationRent",
    values,
  });
};

const Form = (props: Props) => {
  const merchantData = useSelector((state:any) => state.Merchant?.merchant);
  const merchantCode =merchantData?.code
  const merchantCodeUpperCase =merchantCode ? merchantCode?.toUpperCase() : '';
  const [date, setDate] = useSetState<any>({
    fromDate: moment().add(2, "months"),
    endDate: moment().add(2, "months").add(1, "days"),
    numberOfNights: 1,
  });
  const [state, setState] = useSetState<any>({
    images: {},
    addressImage: null,
  });
  const [priceList, setPriceList] = useSetState<any>({
    AllPromotionPrice: 0,
    ApplyCurrentlyPromotionPrice: 0,
  });

  const [thumbnail, setThumbnail] = useState<any>({});
  const [isVisible, setIsVisible] = useState(false);

  const form = useForm<any>({
    defaultValues: {
      price: 0,
    },
    validationSchema: schema,
  });

  const onSubmit = (formData: any) => {
    const uploadList: any[] = [];
    if (!form.getValues("verifyTerm")) {
      toast.error("Bạn chưa đồng ý với các chính sách cho thuê !");
      return;
    }
    if (
      form.getValues("verifyStatus") &&
      !state.images.image1 &&
      !state.images.image2 &&
      !state.images.image3
    ) {
      toast.error("Hãy chọn đầy đủ thông tin xác minh");
      return;
    }
    if (state.images.image1?.Path) {
      uploadList.push(
        handleUploadAvatar(dataURLtoFile(state.images.image1.Path, state.images.image1.Name))
      );
    }
    if (state.images.image2?.Path) {
      uploadList.push(
        handleUploadAvatar(dataURLtoFile(state.images.image2.Path, state.images.image2.Name))
      );
    }
    if (state.images.image3?.Path) {
      uploadList.push(
        handleUploadAvatar(dataURLtoFile(state.images.image3.Path, state.images.image3.Name))
      );
    }
    if (thumbnail.Path) {
      uploadList.push(handleUploadAvatar(dataURLtoFile(thumbnail.Path, thumbnail.Name)));
    }
    Promise.all(uploadList).then(async (uploadRes) => {
      const values: RentProduct = {
        Id: Common.guid(),
        AddressId: formData.addressName?.value,
        Adult: +formData.adult,
        Children: +formData.children,
        BathRoom: formData.bathRoom?.value,
        DoubleBed: formData.doubleBed?.value,
        FromAge: formData.ageRange[0],
        ToAge: formData.ageRange[1],
        IncludeBreakfast: stringBooleanToRealBoolean(formData.includeBreakfast),
        HasKitchen: stringBooleanToRealBoolean(formData.hasKitchen),
        Price: +formData.price,
        SingleBed: formData.singleBed?.value,
        BedRoom: formData.bedRoom?.value,
        VerifyStatus: formData.verifyStatus,
        VerifyTerm: formData.verifyTerm,
        ContractCode: formData.contractCode,
        FromDate: formatDateTime(date.fromDate, "MM/DD/YYYY"),
        ToDate: formatDateTime(date.endDate, "MM/DD/YYYY"),
        ContractInformationOwnerImageId: uploadRes[0]?.data.Data[0]?.Id,
        ContractRoomImageId: uploadRes[1]?.data.Data[0]?.Id,
        ContractVerifyImageId: uploadRes[2]?.data.Data[0]?.Id,
        PromotionVacationRents: formData.promotions || [],
        Images: Common.createRelationObjectArray(
          formData.images?.map((img) => img.id) || [],
          formData.images?.find((img) => img.isFeatured === true)?.id
        ),

        ...getCommonValues(["ActionBy", "MerchantId", "LanguageId"]),
      };
      asyncToast(createRentProduct(values), { pending: "Đang tạo sản phẩm..." });
    });
  };
  const uploadAvatar = (file: any, type: string) => {
    if (file) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = document.createElement("img");
        img.onload = function (e) {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");

          ctx?.drawImage(img, 0, 0);

          var MAX_WIDTH = 800;
          var MAX_HEIGHT = 600;
          var width = img.width;
          var height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0, width, height);
          var dataUrl = canvas.toDataURL(file.type);
          if (type === "thumbnail") {
            setThumbnail({ Id: Common.guid(), Path: dataUrl, Name: file.name });
          } else {
            setState({
              images: {
                ...state.images,
                [type]: {
                  Id: Common.guid(),
                  Path: dataUrl,
                  Name: file.name,
                },
              },
            });
          }
        };
        img.src = e.target?.result as any;
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(form.errors)) {
      scrollToField("form", Object.keys(form.errors)[0]);
    }
  }, [form.errors]);
  const handleApplyPromotion = (arr: any[], isDelete?: boolean, price?: number) => {
    form.setValue("test", 33333);
    asyncToast(
      calCulatePromotion({
        Id: Common.guid(),
        Amount: price || +form.watch("price"),
        FromDate: formatDateTime(date.fromDate, "MM/DD/YYYY"),
        PromotionItems: arr || [],
        ...getCommonValues(["ModifiedBy", "ModifiedDate"]),
      }),
      {
        pending: !isDelete
          ? "Đang áp dụng chương trình khuyến mãi..."
          : "Đang bỏ áp dụng mã giảm giá...",
      }
    ).then((res) => {
      //console.log(JSON.parse(res.data.Message)[MessagePromotionResponse.AllPromotion], "2533");
      setPriceList({
        AllPromotionPrice: JSON.parse(res.data.Message)[MessagePromotionResponse.AllPromotion],
      });
      setPriceList({
        ApplyCurrentlyPromotionPrice: JSON.parse(res.data.Message)[
          MessagePromotionResponse.ApplyCurrently
        ],
      });
    });
  };

  const priceAfterDiscount: number = useMemo(() => {
    return form.watch("promotionType") === "all"
      ? priceList.AllPromotionPrice
      : priceList.ApplyCurrentlyPromotionPrice;
  }, [priceList, form]);
  const ownerRevenue = useMemo(() => {
    return +form.watch("price") * (90 / 100);
  }, [form]);
  useEffect(() => {});

  return (
    <form
      id="form"
      onSubmit={form.handleSubmit(onSubmit)}
      className="form row fv-plugins-bootstrap5 fv-plugins-framework"
    >
      <Controller
        as={({ onChange, value, ref }) => (
          <VoucherList
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            onSubmit={handleApplyPromotion}
            onChange={onChange}
            value={value}
          />
        )}
        control={form.control}
        name={"promotions"}
      />

      <div className="tw-grid tw-grid-cols-9 tw-gap-2">
        <div className="tw-col-span-6  mb-7 me-7 me-lg-10 gap-7 gap-lg-10">
          {/*begin::Order details*/}

          {/*end::Order details*/}
          {/*begin::Order details*/}
          <div className="card card-flush py-4">
            {/*begin::Card header*/}
            <div className="card-header">
              <div className="card-title">
                <h2>Thông tin sản phẩm cho thuê</h2>
              </div>
            </div>
            {/*end::Card header*/}
            {/*begin::Card body*/}
            <div className="card-body pt-0">
              {/*begin::Billing address*/}
              <div className="d-flex flex-column gap-5 gap-md-7">
                {/*begin::Title*/}

                {/*begin::Input group*/}
                <FormItems
                  form={form}
                  formKey="form"
                  items={[
                    {
                      key: "addressName",
                      label: "Tên khu nghỉ dưỡng",
                      required: true,
                      inputProps: {
                        noOptionsMessage: (
                          <span>
                            Khu nghỉ chưa có trong hệ thống. Để thêm khu nghỉ, liên hệ với chúng tôi{" "}
                            <a target="_blank" href="https://1share.labo.io/vi-vn/pages/lien-he">
                              tại đây
                            </a>
                          </span>
                        ),
                      },
                      type: "select",
                      dataSource: useQueryAddresses,
                    },
                  ]}
                />
                <Box
                  sx={{
                    display: "grid",
                    gap: "10px",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    "@media (min-width: 780px)": {
                      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    },
                  }}
                >
                  <FormItems
                    form={form}
                    formKey="form"
                    items={[
                      {
                        key: "adult",
                        label: "Adult",
                        required: true,
                        inputProps: {
                          type: "number",

                          defaultValue: 0,
                        },
                      },
                      {
                        key: "children",
                        label: "Children",
                        required: true,
                        inputProps: {
                          type: "number",

                          defaultValue: 0,
                        },
                      },
                      {
                        key: "ageRange",
                        label: "Tuổi của trẻ em",
                        type: "slider",
                        inputProps: {
                          min: 0,
                          max: 11,
                        },
                      },
                    ]}
                  />
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    gap: "10px",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    "@media (min-width: 780px)": {
                      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    },
                  }}
                >
                  <FormItems
                    form={form}
                    formKey="form"
                    items={[
                      {
                        key: "bedRoom",
                        label: "Number Of Sleeping Room",
                        required: true,
                        type: "select",
                        dataSource: _.range(1, 9).map((v) => ({ label: v, value: v })),
                      },
                      {
                        key: "doubleBed",
                        label: "Number Of Double Bed",

                        type: "select",
                        dataSource: _.range(1, 9).map((v) => ({ label: v, value: v })),
                      },
                      {
                        key: "singleBed",
                        label: "Number Of Single Bed",

                        type: "select",
                        dataSource: _.range(1, 9).map((v) => ({ label: v, value: v })),
                      },
                    ]}
                  />
                </Box>
                <div className="tw-grid tw-grid-cols-1 tw-gap-5 md:tw-grid-cols-2">
                  <FormItems
                    form={form}
                    formKey="form"
                    items={[
                      {
                        key: "bathRoom",
                        label: "BathRoom",
                        required: true,
                        type: "select",
                        dataSource: _.range(1, 9).map((v) => ({ label: v, value: v })),
                      },
                      {
                        key: "hasKitchen",
                        label: "Kitchen",

                        type: "radio",
                        inputProps: {
                          defaultValue: "false",
                        },
                        dataSource: [
                          { value: true, label: "Có" },
                          { value: false, label: "Không" },
                        ],
                      },
                    ]}
                  />
                </div>

                <FormItems
                  form={form}
                  formKey="form"
                  items={[
                    {
                      key: "includeBreakfast",
                      label: "Include Breakfast",

                      type: "radio",
                      inputProps: {
                        defaultValue: "false",
                      },
                      dataSource: [
                        { value: true, label: "Có" },
                        { value: false, label: "Không" },
                      ],
                    },
                  ]}
                />
                <div className="tw-grid tw-gap-5 tw-grid-cols-1 md:tw-grid-cols-3">
                  <div className="d-flex flex-column">
                    <FormItemLabel required label="Check-in date" />
                    <DateRangePicker
                      onCancel={(e, picker) => {
                        picker.element.val("");
                      }}
                      initialSettings={{
                        showDropdowns: true,
                        autoApply: true,
                        startDate: date.fromDate,
                       

                        autoUpdateInput: false,
                        locale: {
                          cancelLabel: true,
                        },
                      }}
                      onApply={(event, picker) => {
                        setDate({
                          numberOfNights: moment(picker.endDate).diff(
                            moment(picker.startDate),
                            "days"
                          ),
                        });
                        setDate({
                          fromDate: picker.startDate,
                          endDate: picker.endDate,
                        });

                        /*  setFilterParams({
                    from: moment(picker.startDate).format("YYYY-MM-DD"),
                    to: moment(picker.endDate).format("YYYY-MM-DD"),
                  }); */
                      }}
                    >
                      <input
                        /*  placeholder={formatMessage({ id: "Pick date range" })} */
                        value={moment(date.fromDate).format("DD/MM/YYYY")}
                        className="form-control "
                      />
                    </DateRangePicker>
                  </div>
                  <div>
                    <FormItemLabel required label="Check-out date" />
                    <DateRangePicker
                      onCancel={(e, picker) => {
                        picker.element.val("");
                      }}
                      initialSettings={{
                        showDropdowns: true,
                        autoApply: true,
                     
                        autoUpdateInput: false,
                        locale: {
                          cancelLabel: true,
                        },
                      }}
                      onApply={(event, picker) => {
                        setDate({
                          startDate: moment(picker.startDate).format("DD/MM/YYYY"),
                          endDate: moment(picker.endDate).format("DD/MM/YYYY"),
                        });
                        /*  setFilterParams({
                    from: moment(picker.startDate).format("YYYY-MM-DD"),
                    to: moment(picker.endDate).format("YYYY-MM-DD"),
                  }); */
                      }}
                    >
                      <input
                        /*  placeholder={formatMessage({ id: "Pick date range" })} */
                        value={moment(date.endDate).format("DD/MM/YYYY")}
                        className="form-control "
                      />
                    </DateRangePicker>
                  </div>
                  <div>
                    <FormItemLabel label="Number of nights" />
                    <div className="fw-bold mt-4 ms-8 fs-2">{date.numberOfNights}</div>
                  </div>
                </div>

                <div className="tw-grid tw-gap-5 tw-grid-cols-1 md:tw-grid-cols-2">
                  <FormItems
                    form={form}
                    formKey="form"
                    items={[
                      {
                        key: "price",
                        label: "Rent Price",
                        required: true,
                        inputProps: {
                          type: "number",
                          onBlur: (e) => {
                            if (form.watch("promotions")?.length > 0) {
                              handleApplyPromotion(form.watch("promotions"), false, e.target.value);
                            }
                          },
                        },
                      },
                    ]}
                  />
                </div>

                <div className="d-flex fs-5 align-items-center">
                  <span className="fw-bolder">Chương trình chiết khấu</span>
                  <Tooltip title="Chương trình chiết khấu sẽ được tính theo giá sau giảm của chương trình chiết khấu trước đó">
                    <i className="fas fa-exclamation-circle ms-2 mb-1"></i>
                  </Tooltip>
                  <div
                    onClick={() => {
                      if (+form.watch("price") > 0) {
                        setIsVisible(true);
                      } else {
                        toast.info(
                          "Giá cho thuê phải lơn hơn 0 để áp dụng chương trình khuyến mại"
                        );
                      }
                    }}
                    className="ms-4 d-flex align-items-center text-primary cursor-pointer hover:tw-underline"
                  >
                    <i className="bi bi-plus text-primary"></i>
                    <span>Thêm chương trình khuyến mãi</span>
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  {form.watch("promotions")?.length > 0 &&
                    form
                      .watch("promotions")

                      .map((item) => (
                        <Stack direction="row" spacing={3}>
                          <Chip
                            sx={{ fontSize: "18px" }}
                            label={`${item.Name} | ${
                              item.ApplyBeforeCheckIn
                                ? "Áp dụng trước ngày check-in " + item.ApplyBeforeCheckIn + " ngày"
                                : "Áp dụng luôn"
                            }`}
                            color={!item.ApplyBeforeCheckIn ? "primary" : undefined}
                            onDelete={() => {
                              const filteredArr = form
                                .watch("promotions")
                                .filter((tempItem) => tempItem.PromotionId !== item.PromotionId);

                              form.setValue("promotions", filteredArr);
                              handleApplyPromotion(filteredArr, true);
                            }}
                          />
                        </Stack>
                      ))}
                </div>
                <Divider />

                <FormItems
                  form={form}
                  formKey="form"
                  items={[
                    {
                      key: "promotionType",
                      type: "radio",
                      containerProps: "mb-0",
                      inputProps: {
                        defaultValue: "all",
                      },
                      dataSource: [
                        {
                          label: "Tất cả các chương trình chiết khấu",
                          value: "all",
                        },
                        {
                          label: "Chỉ chương trình chiết khấu đang có hiệu lực",
                          value: "1",
                        },
                      ],
                    },
                  ]}
                />

                <div className="tw-grid tw-grid-cols-2 gap-5 ">
                  <Typography>Tổng tiền chiết khấu</Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(
                      priceAfterDiscount ? +form.watch("price") - priceAfterDiscount : undefined
                    )}
                  </Typography>
                  <Typography>Giá cho thuê sau chiết khấu</Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(priceAfterDiscount)}
                  </Typography>
                  <Typography>
                    Phí cho thuê thành công
                    <i className="d-block">10% giá cho thuê, tối thiểu 500000đ</i>
                  </Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(+form.watch("price") - ownerRevenue)}
                  </Typography>
                  <Typography>
                    Doanh thu cho thuê của chủ sở hữu(chưa trừ thuế)
                    <i className="d-block">90% giá cho thuê</i>
                  </Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(+form.watch("price") * (90 / 100))}
                  </Typography>
                  <Typography>
                    Thuế thu nhập cá nhân
                    <i className="d-block">10% doanh thu cho thuê</i>
                  </Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(ownerRevenue * (10 / 100))}
                  </Typography>
                  <Typography variant="h5">Tổng doanh thu ròng</Typography>
                  <Typography className="tw-justify-self-end">
                    {Common.formatMoney(
                      +form.watch("price") -
                        (+form.watch("price") - ownerRevenue) -
                        ownerRevenue * (10 / 100)
                    )}
                  </Typography>
                </div>
                <Divider />
                {/*end::Input group*/}
                {/*begin::Checkbox*/}
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    ref={form.register}
                    name="verifyStatus"
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setState({
                          image: {},
                        });
                      }
                    }}
                    className="form-check-input"
                    type="checkbox"
                    id="verifyStatus"
                  />
                  <label className="form-check-label" htmlFor="verifyStatus">
                    Tôi muốn xác minh kỳ nghỉ
                  </label>
                </div>
                {form.watch("verifyStatus") && (
                  <div className="notice  bg-light-warning rounded border-warning border border-dashed rounded-3 p-6">
                    <FormItems
                      form={form}
                      formKey="form"
                      items={[
                        {
                          key: "contractCode",
                          label: "Contract Code",
                        },
                      ]}
                    />
                    <div className="tw-grid tw-grid-cols-3 tw-gap-3">
                      <div>
                        <label className="fs-5 fw-bolder mb-2"> Thông tin khu nghỉ</label>
                        {/*end::Label*/}
                        {/*begin::Input*/}
                        <i className="pb-10 d-block h-lg-80px">
                          Upload ảnh trang có thông tin khu nghỉ trên hợp đồng
                        </i>
                        <div className="image-input image-input-outline">
                          <div
                            className="image-input-wrapper tw-bg-white w-125px h-125px"
                            style={{
                              backgroundImage: `url(${state.images.image1?.Path})`,
                              backgroundSize: "cover",
                            }}
                          />

                          <label
                            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                            data-kt-image-input-action="change"
                            data-bs-toggle="tooltip"
                            title=""
                            data-bs-original-title="Change avatar"
                          >
                            <i className="bi bi-pencil-fill fs-7" />
                            {/*begin::Inputs*/}
                            <input
                              type="file"
                              name="avatar"
                              accept=".png, .jpg, .jpeg"
                              onChange={(event: any) =>
                                uploadAvatar(event.target.files[0], "image1")
                              }
                            />
                            {/*end::Inputs*/}
                          </label>
                        </div>
                        <div className="fv-plugins-message-container invalid-feedback" />
                      </div>
                      <div>
                        <label className="fs-5 fw-bolder mb-2">Thông tin chủ sở hữu</label>
                        <i className="pb-10 d-block h-lg-80px">
                          Upload ảnh trang có thông tin chủ sở hữủ trên hợp đồng
                        </i>
                        {/*end::Label*/}
                        {/*begin::Input*/}

                        <div className="image-input image-input-outline">
                          <div
                            className="image-input-wrapper tw-bg-white w-125px h-125px"
                            style={{
                              backgroundImage: `url(${state.images.image2?.Path})`,
                              backgroundSize: "cover",
                            }}
                          />

                          <label
                            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                            data-kt-image-input-action="change"
                            data-bs-toggle="tooltip"
                            title=""
                            data-bs-original-title="Change avatar"
                          >
                            <i className="bi bi-pencil-fill fs-7" />
                            {/*begin::Inputs*/}
                            <input
                              type="file"
                              name="avatar"
                              accept=".png, .jpg, .jpeg"
                              onChange={(event: any) =>
                                uploadAvatar(event.target.files[0], "image2")
                              }
                            />

                            {/*end::Inputs*/}
                          </label>
                        </div>

                        <div className="fv-plugins-message-container invalid-feedback" />
                      </div>
                      <div>
                        <label className="fs-5 fw-bolder mb-2">Xác nhận hợp lệ</label>
                        <i className="pb-10 d-block tw-line-clamp-1 h-lg-80px">
                          Upload ảnh trang có Chữ ký và Dấu mộc của chủ sở hữu và khu nghỉ trên hợp
                          đồng hoặc thẻ sở hữu cùng các văn bản khác nếu có
                        </i>
                        {/*end::Label*/}
                        {/*begin::Input*/}

                        <div className="image-input image-input-outline">
                          <div
                            className="image-input-wrapper w-125px tw-bg-white h-125px"
                            style={{
                              backgroundImage: `url(${state.images.image3?.Path})`,
                              backgroundSize: "cover",
                            }}
                          />

                          <label
                            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                            data-kt-image-input-action="change"
                            data-bs-toggle="tooltip"
                            title=""
                            data-bs-original-title="Change avatar"
                          >
                            <i className="bi bi-pencil-fill fs-7" />
                            {/*begin::Inputs*/}
                            <input
                              type="file"
                              name="avatar"
                              accept=".png, .jpg, .jpeg"
                              onChange={(event: any) =>
                                uploadAvatar(event.target.files[0], "image3")
                              }
                            />

                            {/*end::Inputs*/}
                          </label>
                        </div>

                        <div className="fv-plugins-message-container invalid-feedback" />
                      </div>
                    </div>
                  </div>
                )}

                <div className="dropzone dz-clickable tw-text-left h-300px tw-overflow-y-auto">
                  <div className="fw-bolder mb-3 fs-3">Chính sách cho thuê dành cho hội viên</div>
   1. Quyền sở hữu: 
Website này được đầu tư và thuộc sở hữu của Công ty cổ phần VClass (sau đây được gọi tắt là “Chúng tôi”), bao gồm: Thương hiệu, hình ảnh, nội dung bài viết; không cho phép sử dụng, sao chép hay đại diện website (cho dù là toàn bộ hay chỉ một phần) trên bất kỳ phương tiện truyền thông nào, cho bất kỳ mục đích nào khác.
Việc chỉnh sửa website, nội dung, và sắp xếp thuộc về thẩm quyền của Chúng tôi. Sự chỉnh sửa, thay đổi, phân phối hoặc tái sử dụng những nội dung trong trang này vì bất kì mục đích nào khác được xem như vi phạm quyền sở hữu hợp pháp của Chúng tôi.
<br />
2. Trách nhiệm của người sử dụng:
Khi truy cập vào website này, Quý khách đã đồng ý chấp nhận mọi rủi ro. Chúng tôi và các bên đối tác khác không chịu trách nhiệm về bất kỳ tổn thất nào do những hậu quả trực tiếp, tình cờ hay gián tiếp; những thất thoát, chi phí (bao gồm chi phí pháp lý, chi phí tư vấn hoặc các khoản chi tiêu khác) có thể phát sinh trực tiếp hoặc gián tiếp do việc truy cập website hoặc khi tải dữ liệu về máy; những tổn hại gặp phải do virus, hành động phá hoại trực tiếp hay gián tiếp của hệ thống máy tính khác, đường dây điện thoại, phần cứng, phần mềm, lỗi chương trình, hoặc bất kỳ các lỗi nào khác; đường truyền dẫn của máy tính hoặc nối kết mạng bị chậm…
<br />
3. Về nội dung trên website:
Tất cả những thông tin ở đây được cung cấp đến Quý khách một cách trung thực như bản thân sự việc. Các cá nhân và tổ chức không được phép sử dụng nội dung trên website này với mục đích thương mại mà không có sự đồng thuận từ Chúng tôi bằng văn bản. Mặc dù Chúng tôi luôn cố gắng cập nhật thường xuyên các nội dung tại website, nhưng Chúng tôi không bảo đảm rằng các thông tin đó là mới nhất, chính xác hay đầy đủ. Tất cả các nội dung website có thể được thay đổi bất kỳ lúc nào.
<br />
4. Về việc sử dụng thông tin:
Chúng tôi sẽ không sử dụng thông tin cá nhân của Quý khách trên website này nếu chưa được sự cho phép từ Quý khách. Nếu Quý khách đồng ý cung cấp thông tin cá nhân, Quý khách sẽ được bảo vệ. Thông tin của Quý khách sẽ được sử dụng với mục đích, liên lạc với Quý khách để thông báo các thông tin cập nhật từ Chúng tôi: như xác nhận đơn hàng, giao hàng, cung cấp thông tin sản phẩm...
Thông tin cá nhân của Quý khách sẽ không được gửi cho bất kỳ bên thứ ba nào sử dụng ngoài trang website: clubhouseasia.com nếu chưa được sự cho phép từ Quý khách, và yêu cầu cung cấp bởi luật pháp. Nếu Chúng tôi chia sẻ thông tin cá nhân của bạn cho các nhà cung cấp dịch vụ, công ty quảng cáo, các công ty đối tác liên quan, thì Chúng tôi cũng yêu cầu họ bảo vệ thông tin cá nhân của bạn như cách chúng tôi thực hiện.
 <br />
5. Liên kết với các trang khác:
Mặc dù website này có thể được liên kết với những trang khác, Chúng tôi không trực tiếp hoặc gián tiếp tán thành, tổ chức, tài trợ, đứng sau hoặc sáp nhập với những trang đó, trừ phi điều này được nêu ra rõ ràng. 
Khi truy cập vào website của Chúng tôi, Quý khách phải hiểu và chấp nhận rằng Chúng tôi không thể kiểm soát tất cả những trang liên kết (nếu có) với trang website của Chúng tôi và cũng không chịu trách nhiệm cho nội dung của những trang liên kết.
 <br />
6. Đưa thông tin lên trang website:
Quý khách không được đưa lên, hoặc chuyển tải lên website tất cả những hình ảnh, từ ngữ khiêu dâm, thô tục, xúc phạm, phỉ báng, bôi nhọ, đe dọa, những thông tin không hợp pháp hoặc những thông tin có thể đưa đến việc vi phạm pháp luật, trách nhiệm pháp lý. Chúng tôi và tất cả các bên có liên quan đến việc xây dựng và quản lý website không chịu trách nhiệm hoặc có nghĩa vụ pháp lý đối với những phát sinh từ nội dung do Quý khách tải lên trang website.
 <br />
7. Luật áp dụng:
Mọi hoạt động phát sinh từ trang web có thể sẽ được phân tích và đánh giá theo luật pháp Việt Nam.
                </div>

                <div className="form-check form-check-custom form-check-solid">
                  <input
                    ref={form.register}
                    name="verifyTerm"
                    className="form-check-input"
                    type="checkbox"
                    id="verifyTerm"
                  />
                  <label className="form-check-label" htmlFor="verifyTerm">
                    Tôi đã đọc và đồng ý các điều khoản
                  </label>
                </div>

                {/*end::Checkbox*/}
                {/*begin::Shipping address*/}
                <div className="d-none d-flex flex-column gap-5 gap-md-7">
                  {/*begin::Title*/}
                  <div className="fs-3 fw-bold mb-n2">Shipping Address</div>
                  {/*end::Title*/}
                  {/*begin::Input group*/}
                  <div className="d-flex flex-column flex-md-row gap-5">
                    <div className="fv-row flex-row-fluid">
                      {/*begin::Label*/}
                      <label className="form-label">Address Line 1</label>
                      {/*end::Label*/}
                      {/*begin::Input*/}
                      <input
                        className="form-control"
                        name="kt_ecommerce_edit_order_address_1"
                        placeholder="Address Line 1"
                        defaultValue=""
                      />
                      {/*end::Input*/}
                    </div>
                    <div className="flex-row-fluid">
                      {/*begin::Label*/}
                      <label className="form-label">Address Line 2</label>
                      {/*end::Label*/}
                      {/*begin::Input*/}
                      <input
                        className="form-control"
                        name="kt_ecommerce_edit_order_address_2"
                        placeholder="Address Line 2"
                      />
                      {/*end::Input*/}
                    </div>
                  </div>
                  {/*end::Input group*/}
                  {/*begin::Input group*/}
                  <div className="d-flex flex-column flex-md-row gap-5">
                    <div className="flex-row-fluid">
                      {/*begin::Label*/}
                      <label className="form-label">City</label>
                      {/*end::Label*/}
                      {/*begin::Input*/}
                      <input
                        className="form-control"
                        name="kt_ecommerce_edit_order_city"
                        placeholder=""
                        defaultValue=""
                      />
                      {/*end::Input*/}
                    </div>
                    <div className="fv-row flex-row-fluid">
                      {/*begin::Label*/}
                      <label className="form-label">Postcode</label>
                      {/*end::Label*/}
                      {/*begin::Input*/}
                      <input
                        className="form-control"
                        name="kt_ecommerce_edit_order_postcode"
                        placeholder=""
                        defaultValue=""
                      />
                      {/*end::Input*/}
                    </div>
                    <div className="fv-row flex-row-fluid">
                      {/*begin::Label*/}
                      <label className="form-label">State</label>
                      {/*end::Label*/}
                      {/*begin::Input*/}
                      <input
                        className="form-control"
                        name="kt_ecommerce_edit_order_state"
                        placeholder=""
                        defaultValue=""
                      />
                      {/*end::Input*/}
                    </div>
                  </div>
                  {/*end::Input group*/}
                  {/*begin::Input group*/}

                  {/*end::Input group*/}
                </div>
                {/*end::Shipping address*/}
              </div>
              {/*end::Billing address*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Order details*/}
          <div className="d-flex justify-content-end mt-5">
            {/*begin::Button*/}
            <a
              href="/rent-vacation/list"
              id="kt_ecommerce_edit_order_cancel"
              className="btn btn-light me-5"
            >
              Hủy
            </a>
            {/*end::Button*/}
            {/*begin::Button*/}
            <button type="submit" form="form" className="btn btn-primary">
              <span className="indicator-label">Đăng tin</span>
              <span className="indicator-progress">
                Please wait...{" "}
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
              </span>
            </button>
            {/*end::Button*/}
          </div>
        </div>
        {/*begin::Aside column*/}
        <div className="tw-col-span-3 d-flex flex-column gap-7 gap-lg-10 w-100 mb-7 me-lg-10">
          <div className="card card-flush py-4">
            {/*begin::Card header*/}
            <div className="card-header">
              {/*begin::Card title*/}
              <div className="card-title">
                <h2>Ảnh sản phẩm</h2>
              </div>

              {/*end::Card title*/}
              {/*begin::Card toolbar*/}

              {/*begin::Card toolbar*/}
            </div>
            {/*end::Card header*/}
            {/*begin::Card body*/}
            <div className="card-body text-center pt-0">
              {/*begin::Image input*/}
              {/*begin::Image input placeholder*/}
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\n                .image-input-placeholder {\n                    background-image: url('/metronic8/demo1/assets/media/svg/files/blank-image.svg');\n                }\n\n                [data-bs-theme=\"dark\"] .image-input-placeholder {\n                    background-image: url('/metronic8/demo1/assets/media/svg/files/blank-image-dark.svg');\n                }                \n            ",
                }}
              />
              {/*end::Image input placeholder*/}
              <div
                className="image-input w-75 image-input-empty image-input-outline image-input-placeholder mb-3"
                data-kt-image-input="true"
              >
                {/*begin::Preview existing avatar*/}
                <div
                  className="image-input-wrapper w-100 h-200px"
                  style={{
                    backgroundImage: `url(${thumbnail.Path})`,
                    backgroundSize: "cover",
                  }}
                />
                {/*end::Preview existing avatar*/}
                {/*begin::Label*/}
                <label
                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  aria-label="Change avatar"
                  data-bs-original-title="Change avatar"
                  data-kt-initialized={1}
                >
                  <i className="bi bi-pencil-fill fs-7" />
                  {/*begin::Inputs*/}
                  <input
                    type="file"
                    onChange={(event: any) => uploadAvatar(event.target.files[0], "thumbnail")}
                    name="avatar"
                    accept=".png, .jpg, .jpeg"
                  />
                  <input type="hidden" name="avatar_remove" />
                  {/*end::Inputs*/}
                </label>
                {/*end::Label*/}
                {/*begin::Cancel*/}

                {/*end::Cancel*/}
                {/*begin::Remove*/}
                <span
                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  aria-label="Remove avatar"
                  data-bs-original-title="Remove avatar"
                  data-kt-initialized={1}
                >
                  <i className="bi bi-x fs-2" />
                </span>
                {/*end::Remove*/}
              </div>
              {/*end::Image input*/}
              {/*begin::Description*/}
              <div className="text-muted fs-7"></div>
              {/*end::Description*/}
            </div>
            {/*end::Card body*/}
          </div>
          <div className="card card-flush py-4">
            {/*begin::Card header*/}
            <div className="card-header">
              {/*begin::Card title*/}
              <div className="card-title">
                <h2>Album ảnh sản phẩm</h2>
              </div>

              {/*end::Card title*/}
              {/*begin::Card toolbar*/}

              {/*begin::Card toolbar*/}
            </div>
            {/*end::Card header*/}
            {/*begin::Card body*/}
            <div className="card-body text-center pt-0">
              {/*begin::Image input*/}
              {/*begin::Image input placeholder*/}

              {/*end::Remove*/}

              <Controller
                as={({ onChange, value, ref }) => (
                  <WidgetImage onChange={onChange} value={value} dataSource={useQueryImages} />
                )}
                control={form.control}
                name={"images"}
              />

              {/*end::Image input*/}
              {/*begin::Description*/}
              <div className="text-muted fs-7"></div>
              {/*end::Description*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Thumbnail settings*/}
          {/*begin::Status*/}
          {/*end::Template settings*/}{" "}
        </div>
      </div>

      {/*end::Aside column*/}
      {/*begin::Main column*/}

      {/*end::Main column*/}
    </form>
  );
};

export default Form;
